import clinicLounge from '@/assets/clinic-lounge.jpg?format=webp';
import clinicLoungeSrcset from '@/assets/clinic-lounge.jpg?w=640;768;960;1280&format=webp&as=srcset';
import clinicTreatment from '@/assets/clinic-treatment-room.jpg?format=webp';
import clinicTreatmentSrcset from '@/assets/clinic-treatment-room.jpg?w=640;768;960;1280&format=webp&as=srcset';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

const Structure = () => {
  return (
    <AnimatedSection className="section-padding" id="estrutura">
      <div className="container-mobile">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 md:order-1">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
              Nossa Estrutura
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Corpo, mente e bem-estar em{' '}
              <span className="text-primary">equilíbrio</span>
            </h2>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              Nossa clínica foi projetada para proporcionar uma experiência de 
              acolhimento e cuidado. Com ambientes pensados para seu conforto e 
              bem-estar, unimos equipamentos adequados a um atendimento humanizado.
            </p>
            <ul className="space-y-3">
              {[
                'Ambiente acolhedor',
                'Salas equipadas para cada procedimento',
                'Sala para Reposições de Vitaminas e Minerais Injetáveis',
                'Localização privilegiada em Brasília',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="w-2 h-2 rounded-full bg-primary" />
                  </span>
                  <span className="text-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Images */}
          <div className="order-1 md:order-2">
            <div className="grid grid-cols-2 gap-4">
              {/* Main Image */}
              <div className="col-span-2 relative aspect-[4/3] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src={clinicLounge}
                  srcSet={clinicLoungeSrcset}
                  sizes="(max-width: 768px) 100vw, 45vw"
                  alt="Recepção da Clínica Habitus"
                  className="w-full h-full object-cover"
                  width={1280}
                  height={960}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              {/* Secondary Image */}
              <div className="col-span-2 relative aspect-[16/9] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src={clinicTreatment}
                  srcSet={clinicTreatmentSrcset}
                  sizes="(max-width: 768px) 100vw, 45vw"
                  alt="Sala de tratamento da Clínica Habitus"
                  className="w-full h-full object-cover"
                  width={1280}
                  height={720}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Structure;
